<script setup lang="ts">
</script>

<template>

  <GenericPanel class="relative flex flex-col justify-center items-center px-4 pt-4 pb-2 shadow-sm">
    <LogoImage class="text-4xl animate-bounce"/>
    <span class="text-sm text-indigo-400 font-medium">Loading</span>
  </GenericPanel>

</template>
